<template>
  <div class="content-heatmap-insurance">
    <div class="col-xs-12 col-12 col-sm-10 col-sm-offset-1 offset-sm-1 col-md-8 col-md-offset-2 offset-md-2 mb-15">
      <div class="content-heatmap-insurance__header">
        <h3>{{ content.title }}</h3>

        <p>{{ content.subtitle }}</p>

        <div class="row" style="padding-top: 0">
          <div class="col-xs-12 col-md-6 heatmap-insurance-header__controls">
            <select-filter
              v-model="selectedCountry"
              :selections="countries"
              :fluid="true"
              @input="handleUpdate"
              label="Select country"
              :label-icon="true"
              style="margin: 0px !important"
            />
          </div>
        </div>
      </div>

      <div class="row" style="padding-top: 0">
        <div class="col-xs-12 col-md-6">
          <div class="legend-wrapper male">
            <p class="legend-label text-legend">Males</p>
            <div>
              <div class="legend-wrapper">
                <span class="bar" v-for="i in colorMale" :key="i" :style="{ backgroundColor: i }" />
              </div>
              <div class="legend-wrapper">
                <span class="bar label" v-for="i in label" :key="i">{{ i }}%</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xs-12 col-md-6">
          <div class="legend-wrapper">
            <p class="legend-label text-legend">Females</p>
            <div>
              <div class="legend-wrapper">
                <span class="bar" v-for="i in colorFemale" :key="i" :style="{ backgroundColor: i }" />
              </div>
              <div class="legend-wrapper">
                <span class="bar label" v-for="i in label" :key="i + '-female'">{{ i }}%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- chart here -->
    <div class="col-xs-12 col-12 col-sm-10 col-sm-offset-1 offset-sm-1 col-md-10 col-md-offset-1 offset-md-1 content-heatmap-insurance__chart">
      <HeatmapViz :country="selectedCountry" @data-sanitized="loadCountries" />
    </div>
  </div>
</template>

<script>
import SelectFilter from '@/components/ui/SelectFilter.vue';

export default {
  name: 'HeatmapInsurance',
  components: {
    SelectFilter,
    HeatmapViz: () => import('@/components/content/chapter2/charts/HeatmapViz.vue'),
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadedData: [],
      countries: [],
      selectedCountry: 'ASEAN-6',
      colorMale: ['#D2E4FA','#A5CBF8','#6BA0E0','#437CC7','#005EB8'],
      colorFemale: ['#FAD7E1','#FDC4D0','#FE94A7','#F27783','#F95D78'],
      label: [0, 20, 40, 60, 80, 100],
    };
  },
  methods: {
    loadCountries(data) {
      this.countries = data.map((d) => d.key);
    },
    handleUpdate(country) {
      this.selectedCountry = country;
    },
  },
};
</script>

<style lang="scss" scoped>
.content-heatmap-insurance {
  background-color: #ffffff;

  &__header {
    margin-bottom: 30px;

    .heatmap-insurance-header__commentary {
      background-color: #f0f0f0;
      border-radius: 5px;
      padding: 10px;

      p {
        margin-bottom: 0;
      }
    }
  }
}

.legend-wrapper {
  display: flex;

  .bar {
    width: 50px;
    height: 24px;
    display: flex;
    border: 1px solid #e8e8e8;
    border-right: unset;

    &.bar:last-child {
      border-right: 1px solid #e8e8e8;
    }

    &.label {
      position: relative;
      left: -13px;
      color: #595959;
      font-weight: 400;
      border: unset;
      font-size: 13px;
    }

    &.label:last-child {
      width: 0px;
      border: unset;
    }
  }

  @media #{map-get($media-breakpoints, 'mobile')} {
    .bar {
      width: 50px;
      height: 20px;

      &.label {
        position: relative;
        left: -11px;
      }
    }
  }

  .legend-label {
    width: unset;
    margin-right: 15px;
    @media #{map-get($media-breakpoints, 'mobile')} {
      width: 54px;
      text-align: left;
    }

    @media #{map-get($media-breakpoints, 'tablet')} {
      width: 54px;
      text-align: left;
    }
  }

  &.male {
    @media #{map-get($media-breakpoints, 'tablet')} {
      margin-bottom: 5px;
    }

    @media #{map-get($media-breakpoints, 'mobile')} {
      margin-bottom: 5px;
    }
  }
}
</style>
